import { render, staticRenderFns } from "./LocalisationRouteCard.vue?vue&type=template&id=05018673&"
import script from "./LocalisationRouteCard.vue?vue&type=script&lang=ts&"
export * from "./LocalisationRouteCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports